/**
 * The connectivity panel's container: the manager's live state
 * (`useConnectivity`) folded into the panel's view model, and the operator's
 * choice of primary handed back to the manager.
 */
import { useConnectivity, useServices } from '../app/hooks.js';
import { ConnectivityStatus } from '../components/ConnectivityStatus.js';
import { connectivityView } from '../connectivity/view.js';

export function ConnectivityControl() {
  const services = useServices();
  const state = useConnectivity();
  return <ConnectivityStatus view={connectivityView(state, services.nowMs())} onChoosePrimary={(id) => services.connectivity.choose(id)} onConnectLocal={() => services.connectivity.connectLocal()} />;
}
